import { get, post, put, del, getPage } from '@/utils/request'
import type { ApiDefinition } from '@/types'

export interface ApiImportItem {
  index: number
  name: string
  success: boolean
  reason: string
}

export interface ApiImportResult {
  total: number
  success_count: number
  fail_count: number
  items: ApiImportItem[]
}

/**
 * 查询接口定义列表（分页）
 * @param params - 查询参数
 */
export function listApiDefinitions(params: {
  project_id: number
  page?: number
  page_size?: number
  keyword?: string
  method?: string
}) {
  return getPage<ApiDefinition>('/api-definitions', params)
}

/**
 * 获取接口定义详情
 * @param id - 接口 ID
 * @param project_id - 项目 ID
 */
export function getApiDefinition(id: number, project_id: number) {
  return get<ApiDefinition>(`/api-definitions/${id}`, { project_id })
}

/**
 * 创建接口定义
 * @param data - 接口定义创建数据
 */
export function createApiDefinition(data: {
  project_id: number
  module_id?: number
  name: string
  method: string
  path: string
  host?: string
  headers?: string
  query_params?: string
  rest_params?: string
  body_type?: string
  body?: string
  description?: string
  creator_id: number
}) {
  return post<ApiDefinition>('/api-definitions', data)
}

/**
 * 更新接口定义
 * @param id - 接口 ID
 * @param data - 更新数据
 * @param project_id - 项目 ID
 */
export function updateApiDefinition(
  id: number,
  data: Partial<ApiDefinition>,
  project_id: number,
) {
  return put<ApiDefinition>(`/api-definitions/${id}`, data, { params: { project_id } })
}

/**
 * 删除接口定义
 * @param id - 接口 ID
 * @param project_id - 项目 ID
 */
export function deleteApiDefinition(id: number, project_id: number) {
  return del(`/api-definitions/${id}`, { params: { project_id } })
}

/**
 * 批量导入接口定义
 * @param data - 导入参数
 */
export function importApiDefinitions(data: {
  project_id: number
  import_type: string
  content: string
}) {
  return post<ApiImportResult>('/api-definitions/import', data)
}
